import { InputForm, SubmitButton, Textarea, Error } from "components";
import { FaqInput, FaqInputError } from "modules/faq/state/actionType";

interface FAQFormProps {
  handleSave: (event: React.FormEvent<HTMLButtonElement>) => void;
  formData: FaqInput;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  error: FaqInputError;
  loading: boolean;
  header: string;
}

const FAQForm: React.FC<FAQFormProps> = ({
  formData,
  header,
  error,
  loading,
  handleChange,
  handleSave,
}) => {
  return (
    <>
      <form>
        <h2 className="text-lg font-bold">{header}</h2>
        <div>
          <InputForm
            label="Question"
            id="question"
            name="question"
            value={formData.question}
            onChange={handleChange}
          />
          {error.answer && <Error>{error.answer}</Error>}
        </div>
        <div>
          <Textarea
            label="Answer"
            id="answer"
            name="answer"
            value={formData.answer}
            onChange={handleChange}
          />
          {error.answer && <Error>{error.answer}</Error>}
        </div>
        <div className="flex py-2">
          <SubmitButton loading={loading} onClick={handleSave} />
        </div>
      </form>
    </>
  );
};
export default FAQForm;
